import { render, staticRenderFns } from "./NewChartTreeMap.vue?vue&type=template&id=57655239&scoped=true&"
import script from "./NewChartTreeMap.vue?vue&type=script&lang=js&"
export * from "./NewChartTreeMap.vue?vue&type=script&lang=js&"
import style0 from "./NewChartTreeMap.vue?vue&type=style&index=0&id=57655239&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57655239",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
